module.exports = __webpack_public_path__ + "static/CreateShop-ded73689a415ef1b2c3ed502860d85ed.png";